import { Component, OnInit, Input } from '@angular/core';
import { RouteDetailViewModel } from '../../viewModels/route-detail-viewmodel';

@Component({
  selector: 'app-route-info',
  templateUrl: './route-info.component.html',
  styleUrls: ['./route-info.component.scss']
})
export class RouteInfoComponent implements OnInit {
  @Input() routeDetailList: RouteDetailViewModel[];
  @Input() hasProject: boolean;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/route-info/route-info.component.ts